import { render, staticRenderFns } from "./SupInvoiceaddcom.vue?vue&type=template&id=18accce2&scoped=true"
import script from "./SupInvoiceaddcom.vue?vue&type=script&lang=js"
export * from "./SupInvoiceaddcom.vue?vue&type=script&lang=js"
import style0 from "./SupInvoiceaddcom.vue?vue&type=style&index=0&id=18accce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18accce2",
  null
  
)

export default component.exports